import { useEffect, useRef, useState } from "react";

const COPIED_MS = 2000;

interface Props {
  patientId: string;
}

export function PatientIdCopy({ patientId }: Props) {
  const [copied, setCopied] = useState(false);
  const timer = useRef<number>(undefined);

  useEffect(() => () => window.clearTimeout(timer.current), []);

  async function handleClick() {
    if (copied) return;
    try {
      await navigator.clipboard.writeText(patientId);
    } catch {
      return;
    }
    setCopied(true);
    timer.current = window.setTimeout(() => setCopied(false), COPIED_MS);
  }

  return (
    <button
      type="button"
      className={`copy-btn${copied ? " copied" : ""}`}
      title="Copy patient ID"
      aria-label={`Copy patient ID ${patientId}`}
      aria-disabled={copied}
      onClick={() => void handleClick()}
    >
      <span className="copy-btn-label" aria-hidden={copied}>
        {patientId}
      </span>
      <span className="copy-btn-label copy-btn-done" aria-hidden={!copied}>
        Copied
      </span>
    </button>
  );
}
